import { useEffect } from 'react';
import { startIntercomTour } from 'shared/helpers/Intercom';
import { LocalStore, useLocalStore } from 'shared/helpers/Store';

interface IntercomFeatureTourOptions {
  tourId: string;
  isEnabled: boolean;
  seenStateKey: string;
}

export function useIntercomTour({
  tourId,
  isEnabled,
  seenStateKey,
}: IntercomFeatureTourOptions) {
  const tourSeenState = useLocalStore(seenStateKey);

  useEffect(() => {
    if (isEnabled && tourSeenState !== 'seen') {
      startIntercomTour(tourId);
      LocalStore.set(seenStateKey, 'seen');
    }
  }, [isEnabled, tourSeenState, tourId, seenStateKey]);
}
